import {StorageAdapter} from '@/src/core/domain/data/storage'
import {injectable} from 'inversify'

@injectable()
export class MobileStorage implements StorageAdapter {
  async getItem<T>(key: string): Promise<T | null> {
    const {Preferences} = await import('@capacitor/preferences')
    const {value} = await Preferences.get({key})
    if (value) {
      return JSON.parse(value) as T
    }
    return null
  }

  async setItem(key: string, value: any): Promise<void> {
    const {Preferences} = await import('@capacitor/preferences')
    await Preferences.set({
      key,
      value: JSON.stringify(value),
    })
  }

  async removeItem(key: string): Promise<void> {
    const {Preferences} = await import('@capacitor/preferences')
    await Preferences.remove({key})
  }
}
